import { render, staticRenderFns } from "./font-selector.vue?vue&type=template&id=789ec0a6&scoped=true&"
import script from "./font-selector.vue?vue&type=script&lang=js&"
export * from "./font-selector.vue?vue&type=script&lang=js&"
import style0 from "./font-selector.vue?vue&type=style&index=0&id=789ec0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ec0a6",
  null
  
)

export default component.exports